import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    companyAddress: 'Company address',
    descriptions: {
      siret:
        'Your business registration number has 14 digits.\nYou can find it on your registration document, or on your old invoices.',
      tradeName:
        'This name will appear on your invoices to help your customers identify you',
    },
    details: 'Account details',
    rows: {
      activityType: 'NAF / APE code',
      legalName: 'Legal name',
      logo: 'Logo',
      registrationDate: 'Registration date',
      siret: 'SIRET',
      tradeName: 'Trade name',
    },
  },
  fr: {
    companyAddress: 'Domiciliation de l’entreprise',
    descriptions: {
      siret:
        'Le numéro d’immatriculation de votre entreprise a 14 chiffres.\nVous pouvez le trouver sur votre document d’immatriculation, ou sur vos anciennes factures.',
      tradeName:
        'Ce nom apparaîtra sur vos factures pour aider vos clients à vous identifier',
    },
    details: 'Détails du compte',
    rows: {
      activityType: 'Code NAF / APE',
      legalName: 'Nom légal',
      logo: 'Logo',
      registrationDate: 'Date d’immatriculation',
      siret: 'SIRET',
      tradeName: 'Nom commercial',
    },
  },
} as const);

export default locales;
